<template>
  <div class="odd:bg-gray-100 border rounded px-4 flex-1 text-sm border-gray-200">
    <div class="flex -mx-4 justify-between items-center">
      <div class="flex-1 p-4">
        <div class="flex flex-col lg:flex-row items-start lg:items-center -mx-4">
          <div class="flex-1 px-4 space-y-2">
            <h5 class="font-normal text-sm">
              {{ user.fullName }}
            </h5>
            <p class="text-gray-600 text-xs">
              {{ user.name }}
            </p>
          </div>
          <div class="flex-1 px-4">
            {{ user.email }}
          </div>
          <div class="w-32 px-4 capitalize">
            {{ user.status }}
          </div>
        </div>
      </div>

      <div class="flex-none pr-4">
        <RouterLink
          :to="{
            name: 'admin.users.show',
            params: {
              userId: user.id,
            },
          }"
          class="w-10 h-10 flex items-center px-4 py-2 rounded text-blue-600 hover:bg-blue-600 hover:text-white focus:outline-none disabled:text-gray-600 disabled:bg-transparent"
        >
          <FontAwesomeIcon icon="chevron-right" />
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    user: { type: Object, required: true },
    disabled: Boolean,
  },
};
</script>
